import { motion } from "framer-motion";
import { PawPrint, Heart, MessageCircle } from "lucide-react";
import { IMAGES } from "@/data";

const STATS = [
  { icon: PawPrint, title: "Dogs only", desc: "We stick to what we know best!" },
  { icon: Heart, title: "Real love & care", desc: "We'll treat your pup like family" },
  { icon: MessageCircle, title: "Regular updates", desc: "We'll update you with pics & videos." },
];

export default function About() {
  return (
    <section id="about" className="py-24 sm:py-32 scroll-mt-20 bg-background">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="relative"
        >
          <div className="rounded-[2.5rem] overflow-hidden border-4 border-white shadow-[0_25px_60px_-20px_rgba(93,87,107,0.4)] h-[380px] sm:h-[520px] bg-muted">
            <img src={IMAGES.about} alt="Our dogs at home in South Brisbane" loading="eager" decoding="async" className="h-full w-full object-cover object-top" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="text-accent font-bold text-sm tracking-widest uppercase">About Us</span>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl mt-3 mb-6 tracking-tight text-primary">
            Your dog obsessed duo!
          </h2>
          <div className="space-y-5 text-muted-foreground leading-relaxed font-medium">
            <p>
              Hi, we're Lee &amp; Karina, South Brisbane locals who swapped the
              corporate life for something way more fun: spending our days with dogs!
            </p>
            <p>
              We don't have our own furry friends just yet, so Cheeky Pups is how we
              get our daily dog fix. We're on a mission to get as many pups as possible
              out for walkies across South Brisbane, West End, South Bank, Milton,
              Highgate Hill, Petrie Terrace and the CBD, so more dogs can enjoy fresh
              air, exercise and have a happy adventure!
            </p>
            <p>
              Whether it's a lunchtime walk, overnight stay or home welfare visit, we
              keep things personal, playful and dependable, with photo &amp; video
              updates (and GPS-tracked walks) so you're never left wondering.
            </p>
          </div>

          <div className="grid grid-cols-3 gap-4 mt-10">
            {STATS.map((s) => {
              const Icon = s.icon;
              return (
                <div key={s.title} className="rounded-3xl bg-card border border-black/5 shadow-sm p-5" data-testid={`about-stat-${s.title}`}>
                  <Icon className="text-accent mb-3" size={22} />
                  <div className="font-display font-extrabold text-primary" style={{ fontSize: "1.5rem", lineHeight: 1.1 }}>{s.title}</div>
                  <div className="text-sm text-muted-foreground font-medium mt-1">{s.desc}</div>
                </div>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
